<template>
  <div>
    <v-data-table
      :headers="headers"
      :no-data-text="$t('common.nodata')"
      :items="items"
      hide-default-footer
      fixed-header
      :header-props="{ 'sort-icon': '$sortIcon' }"
      class="custom-price-data-table gray10"
    >
      <template v-slot:item.index="{ item }">
        {{ items.indexOf(item) + (pageNo - 1) * pageSize + 1 }}
      </template>

      <template v-slot:item.time="{ item }">
        <span class="font-Regular-12">{{ item.time | dateTimeFilter }}</span>
      </template>

      <template v-slot:item.direction="{ item }">
        <span
          v-if="item.direction == 'BUY'"
          class="success--text font-Regular-12"
        >
          {{ $t("ordersHistory.buy") }}
        </span>
        <span
          v-else-if="item.direction == 'SELL'"
          class="error--text font-Regular-12"
        >
          {{ $t("ordersHistory.sell") }}
        </span>
      </template>

      <template v-slot:item.type="{ item }">
        <span class="font-Regular-12">
          <template v-if="item.source === 'OCO_ORDER'">
            {{ $t("ordersHistory.ocoLimit") }}
          </template>

          <template v-else-if="item.source === 'MANUAL_ORDER'">
            <template v-if="item.type === 'LIMIT_PRICE'">
              {{ $t("ordersHistory.limit") }}
            </template>

            <template v-else-if="item.type === 'MARKET_PRICE'">
              {{ $t("ordersHistory.marketOrder") }}
            </template>
          </template>
        </span>
      </template>

      <template v-slot:item.price="{ item }">
        <span class="font-Regular-12">{{ $thousandMask(item.price) }}</span>
      </template>

      <template v-slot:item.amount="{ item }">
        <div class="price-style justify-center ">
          <span class="font-Regular-12">{{ $thousandMask(item.amount) }} </span>
          <span class="font-Regular-12"> {{ item.coinSymbol }} </span>
        </div>
      </template>

      <template v-slot:item.tradedAmount="{ item }">
        <div class="price-style justify-center">
          <span class="font-Regular-12"
            >{{ $thousandMask(item.tradedAmount) }}
          </span>
          <span class="font-Regular-12"> {{ item.coinSymbol }} </span>
        </div>
      </template>

      <template v-slot:item.turnover="{ item }">
        <div class="price-style justify-center">
          <span class="font-Regular-12"
            >{{ $thousandMask(item.turnover) }}
          </span>
          <span class="font-Regular-12"> {{ item.baseSymbol }} </span>
        </div>
      </template>

      <template v-slot:item.averagePrice="{ item }">
        <span class="font-Regular-12"
          >{{ $thousandMask(item.averagePrice) }}
        </span>
      </template>

      <template v-slot:item.status="{ item }">
        <span
          v-if="item.status === 'COMPLETED'"
          class="warning--text font-Regular-12"
        >
          {{ $t("ordersHistory.finished") }}
        </span>

        <span
          v-else-if="item.status === 'CANCELED'"
          class="error--text font-Regular-12"
        >
          {{ $t("ordersHistory.canceled") }}
        </span>

        <span
          v-if="item.status === 'OVERTIMED'"
          class="warning--text font-Regular-12"
        >
          {{ $t("ordersHistory.expired") }}
        </span>
      </template>

      <template v-slot:item.operation="{ item }">
        <v-btn
          color="primaryX"
          text
          :loading="detailsBtnLoading == item.orderId"
          @click="getDetails(item)"
        >
          {{ $t("ordersHistory.details") }}
        </v-btn>
      </template>
    </v-data-table>
    <!--    detail modal-->
    <v-dialog v-model="isOrderDetailModalOpen" width="500">
      <v-card>
        <v-card-title>
          {{ $t("ordersHistory.orderDetails") }}
        </v-card-title>
        <v-card-text>
          <div class="font-Regular-14 custom-modal-body pb-5">
            <ul v-if="true" class="preconditionDetailList">
              <li class="d-flex justify-space-between mb-5">
                <span class="font-Regular-12 precondition-detail-title">
                  {{ $t("ordersHistory.time") }}</span
                >
                <span class="font-Regular-12">{{
                  order.createdDate | dateTimeFilter
                }}</span>
              </li>

              <li class="d-flex justify-space-between mb-5">
                <span class="font-Regular-12 precondition-detail-title">
                  {{ $t("ordersHistory.type") }}
                </span>
                <span class="font-Regular-12">
                  <template v-if="order.source === 'OCO_ORDER'">
                    {{ $t("ordersHistory.ocoLimit") }}
                  </template>

                  <template v-else-if="order.source === 'MANUAL_ORDER'">
                    <span v-if="order.type === 'LIMIT_PRICE'">
                      {{ $t("ordersHistory.limit") }}
                    </span>

                    <span v-else-if="order.type === 'MARKET_PRICE'">
                      {{ $t("ordersHistory.marketOrder") }}
                    </span>
                  </template>
                </span>
              </li>

              <li class="d-flex justify-space-between mb-5">
                <span class="font-Regular-12 precondition-detail-title">
                  {{ $t("ordersHistory.pairCoin") }}
                </span>
                <span class="font-Regular-12">{{ order.symbol }}</span>
              </li>
              <li class="d-flex justify-space-between mb-5">
                <span class="font-Regular-12 precondition-detail-title">
                  {{ $t("ordersHistory.price") }}
                </span>
                <span class="font-Regular-12">
                  {{
                    order.type === "MARKET_PRICE"
                      ? this.$t("ordersHistory.marketPrice")
                      : order.orderPrice
                  }}
                </span>
              </li>
              <li class="d-flex justify-space-between mb-5">
                <span class="font-Regular-12 precondition-detail-title">
                  {{ $t("ordersHistory.amount") }}
                </span>

                <div class="price-style justify-center">
                  <span class="font-Regular-12"
                    >{{ $thousandMask(order.amount) }}
                  </span>
                  <span v-if="order.symbol" class="font-Regular-12">
                    {{ order.symbol.split("/")[0] }}
                  </span>
                </div>
              </li>
              <li class="d-flex justify-space-between mb-5">
                <span class="font-Regular-12 precondition-detail-title">
                  {{ $t("ordersHistory.turnOver") }}
                </span>
                <div class="price-style justify-center">
                  <span class="font-Regular-12"
                    >{{ $thousandMask(order.turnOver) }}
                  </span>
                  <span v-if="order.symbol" class="font-Regular-12">
                    {{ order.symbol.split("/")[1] }}
                  </span>
                </div>
              </li>
            </ul>

            <div class="table-responsive-wrapper">
              <v-data-table
                :headers="orderDetailColumns"
                :items="orderDetailsData"
                :no-data-text="$t('common.nodata')"
                hide-default-footer
                class="pa-5"
              >
                <template v-slot:item.time="{ item }">
                  {{ item.time | dateTimeFilter }}
                </template>

                <template v-slot:item.price="{ item }">
                  {{ $thousandMask(item.price) }}
                </template>

                <template v-slot:item.turnOver="{ item }">
                  {{ $thousandMask(item.turnover) }}
                </template>
              </v-data-table>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import $thousandMask from "@/mixins/thousandMask";
import { ExchangeService } from "@/services";

export default {
  data() {
    return {
      headers: [
        { text: "#", value: "id", width: "50px", align: "center" },
        {
          text: this.$t("ordersHistory.time"),
          value: "time",
          sortable: true,
          align: "center"
        },
        {
          text: this.$t("ordersHistory.pairCoin"),
          value: "symbol",
          sortable: false,
          align: "center"
        },
        {
          text: this.$t("ordersHistory.orderType"),
          value: "type",
          sortable: false,
          align: "center"
        },
        {
          text: this.$t("ordersHistory.tradeDirection"),
          value: "direction",
          sortable: false,
          align: "center"
        },
        {
          text: this.$t("ordersHistory.price"),
          value: "price",
          sortable: true,
          align: "center"
        },
        {
          text: this.$t("ordersHistory.amount"),
          value: "amount",
          sortable: true,
          align: "center"
        },
        {
          text: this.$t("ordersHistory.tradedAmount"),
          value: "tradedAmount",
          sortable: true,
          align: "center"
        },
        {
          text: this.$t("ordersHistory.averageTradePrice"),
          value: "averagePrice",
          sortable: true,
          align: "center"
        },
        {
          text: this.$t("ordersHistory.turnOver"),
          value: "turnover",
          sortable: true,
          align: "center"
        },
        {
          text: this.$t("ordersHistory.status"),
          value: "status",
          sortable: false,
          align: "center"
        },
        {
          text: this.$t("ordersHistory.refCode"),
          value: "trackingCode",
          sortable: false,
          align: "center"
        },
        {
          text: this.$t("ordersHistory.operation"),
          value: "operation",
          sortable: false,
          align: "center"
        }
      ],
      orderDetailColumns: [
        {
          text: this.$t("ordersHistory.amount"),
          value: "amount",
          width: "60",
          align: "center",
          sortable: false
        },
        {
          text: this.$t("ordersHistory.price"),
          value: "price",
          width: "150",
          align: "center",
          sortable: false
        },
        {
          text: this.$t("ordersHistory.time"),
          value: "time",
          width: "180",
          align: "center",
          sortable: false
        },
        {
          text: this.$t("ordersHistory.turnOver"),
          value: "turnOver",
          width: "180",
          align: "center",
          sortable: false
        }
      ],
      orderDetailsData: [],
      cancelOrderModal: false,
      isOrderDetailModalOpen: false,
      order: {},
      detailsBtnLoading: null,
      orderStopLimitDetailsData: [],
      isOrderStopLimitModalOpen: false
    };
  },
  props: ["items", "pageNo", "pageSize"],
  mixins: [$thousandMask],
  filters: {
    dateTimeFilter(date) {
      return (
        dayjs(date).format("HH:mm") + " - " + dayjs(date).format("YYYY/MM/DD")
      );
    }
  },
  methods: {
    getDetails(data) {
      if (this.detailsBtnLoading !== null) return;
      if (data.source === "MANUAL_ORDER" || data.source === "OCO_ORDER") {
        this.getOrderDetails(data.orderId);
      } else if (
        data.source === "STOP_LIMIT_ORDER" ||
        data.source === "OCO_STOP_LIMIT_ORDER"
      ) {
        this.getStopLimitOrderDetail({
          id: data.orderId
        });
      }
    },
    getOrderDetails(orderID) {
      this.detailsBtnLoading = orderID;
      ExchangeService.getOrderDetails(orderID)
        .then(response => {
          this.orderDetailsData = response.data.data.detail;
          this.order = response.data.data.order;
          this.isOrderDetailModalOpen = true;
        })
        .finally(() => {
          this.detailsBtnLoading = null;
        });
    },
    getStopLimitOrderDetail(orderId) {
      this.detailsBtnLoading = orderId;
      ExchangeService.getPreconditionOrderDetailByOrderID(orderId)
        .then(response => {
          this.orderStopLimitDetailsData = response.data.data;
          this.isOrderStopLimitModalOpen = true;
        })
        .finally(() => {
          this.detailsBtnLoading = null;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
